import request from '@/utils/request_common'

// 查询代理公司详情
export const getAgentInfoApi = () =>
  request({
    url: `/sale/agent/getAgentInfo`,
    method: 'get',
  })

/** 账号管理 */
// 账号列表
export const getGearUserListApi = (params: { keyword: string, typeKey: string }) =>
  request({
    url: `/issue/permission/getGearUserList`,
    method: 'get',
    params
  })

// 账号详情
export const getGearUserInfoByIdApi = (id: number | string) =>
  request({
    url: `/issue/permission/getGearUserInfoById`,
    method: 'get',
    params: { id }
  })
// 账号新增
export const addGearUserApi = (data: any) =>
  request({
    url: `/issue/permission/addGearUser`,
    method: 'post',
    data
  })
// 账号修改
export const editGearUserApi = (data: any) =>
  request({
    url: `/issue/permission/editGearUser`,
    method: 'post',
    data
  })
// 账号删除
export const deleteGearUserApi = (id: number | string) =>
  request({
    url: `/issue/permission/deleteGearUser/${id}`,
    method: 'post',
  })

/** 权限查询 */
// 默认角色列表接口
export const getDefaultRoleListApi = () =>
  request({
    url: `/issue/permission/getDefaultRoleList`,
    method: 'post',
  })

// 根据角色ID查询菜单即是否已选接口
export const getMenuListByRoleIdApi = (fkContactPersonTypeKey: string) =>
  request({
    url: `/issue/permission/getMenuListByRoleId`,
    method: 'get',
    params: { fkContactPersonTypeKey }
  })
// 设置用户菜单权限接口
export const setMenuByRoleIdApi = (data: { fkResourceKeys: string[], fkContactPersonTypeKey: number | string }) =>
  request({
    url: `/issue/permission/setMenuByRoleId`,
    method: 'post',
    data
  })

/** 业务数据管理 */
// 账号列表（权限管理）
export const getPermissionGearUserListApi = (params: { keyword: string, typeKey: string }) =>
  request({
    url: `/issue/permission/getPermissionGearUserList`,
    method: 'get',
    params
  })
// 子代理数据开放设置
export const setSubagentPermissionApi = (params: { fkUserId: number | string, isSubagentPermission: boolean }) =>
  request({
    url: `/issue/permission/setSubagentPermission`,
    method: 'post',
    params
  })
// 查看user能绑定与已绑定的上司列表
export const getIssueUserSuperiorApi = (fkUserId: number) =>
  request({
    url: `/issue/permission/getIssueUserSuperior`,
    method: 'get',
    params: { fkUserId }
  })
// 设置业务上司
export const setIssueUserSuperiorApi = (data: Array<{ fkUserId: number, fkUserSuperiorId: number }>, fkUserId: number) =>
  request({
    url: `/issue/permission/setIssueUserSuperior?fkUserId=${fkUserId}`,
    method: 'post',
    data
  })
// 解除Issue用户上级
export const removeIssueUserSuperiorApi = (data: Array<{ fkUserId: number, fkUserSuperiorId: number }>, fkUserId: number) =>
  request({
    url: `/issue/permission/removeIssueUserSuperior?fkUserId=${fkUserId}`,
    method: 'post',
    data
  })
// 查看issue用户下属
export const getIssueUserSubordinateApi = (fkUserId: number) =>
  request({
    url: `/issue/permission/getIssueUserSubordinate`,
    method: 'get',
    params: { fkUserId }
  })

// 查询子代理列表
export const getAgentDatasApi = () =>
  request({
    url: `/sale/agent/agentDatas`,
    method: 'get',
  })

// 校验手机号或邮箱是否有重复
export const checkGearUserByMobileOrEmailApi = (params: { email?: string, mobile?: string, mobileAreaCode?: string}) =>
  request({
    url: `/issue/permission/checkGearUserByMobileOrEmail`,
    method: 'get',
    params,
  })

// 开启或禁用账号
export const enableGearUserApi = (params: { id: number | string, isEnable: boolean }) =>
  request({
    url: `/issue/permission/enableGearUser`,
    method: 'post',
    params
  })
// BMS 数据开放设置
export const setBmsPermissionApi = (params: { fkUserId: number | string, isBmsPermission: boolean }) =>
  request({
    url: `/issue/permission/setBmsPermission`,
    method: 'post',
    params
  })
// 是否已有配置其他佣金邮箱联系人
export const getExistAccountCommissionEmailApi = (params: { fkAgentId: number | string, fkUserId?: number | string }) =>
  request({
    url: `/issue/permission/getExistAccountCommissionEmail`,
    method: 'get',
    params,
  })
